<template>
  <div class="drugactive-box">
    <img class="bg" src="https://oss.aqdpay.com/appweb/drugActive/drugbg1.png" alt="">
    <div class="btn-active">
      <img src="https://oss.aqdpay.com/appweb/drugActive/couponbtn.png" alt="" @click="goCoupon">
      <img src="https://oss.aqdpay.com/appweb/drugActive/drugbtn.png" alt="" @click="goDrug">
    </div>
    <img class="bg" src="https://oss.aqdpay.com/appweb/drugActive/drugbg2.png" alt="">
  </div>
</template>
<script>
export default {
  methods: {
    goCoupon () {
      dsBridge.call('callNativeView', {
        androidGoPage: '/app/CoupanCenterActivity',
        iosGoPage: 'GXReceiveCouponCenterVC'
      })
    },
    goDrug () {
      dsBridge.call('callNativeView', {
        androidGoPage: '/drug/DrugHomeActivity',
        iosGoPage: 'GXGYHomeViewController'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.drugactive-box {
  background: #ffc36f;
  position: relative;
  min-height: 100vh;
  font-size: 0;
  .bg {
    width: 100%;
  }
}
.btn-active {
  display: flex;
  justify-content: center;
  background: #FFC87B;
  img {
    width: 125px;
    max-height: 45px;
    margin: 15px;
    overflow: hidden;
  }
}
</style>
